import { Radio } from "lucide-react";
import { SmsHealthWidget } from "../admin/SmsHealthWidget";
import { EmailHealthWidget } from "../admin/EmailHealthWidget";
import { SalesforceHealthWidget } from "../admin/SalesforceHealthWidget";
import { CommunicationsExportButton } from "../admin/CommunicationsExportButton";
import { CountryPolicyWidget } from "./CountryPolicyWidget";
import { useITPortalI18n } from "../../i18n/ITPortalI18nContext";

export const CommunicationsTab = () => {
  const { t } = useITPortalI18n();
  return (
    <div className="space-y-6 animate-fade-in" data-testid="it-communications-tab">
      <div className="bg-[#111] border border-lojack-blue-600/30 rounded-2xl p-6 flex items-center justify-between gap-4 flex-wrap">
        <div className="flex items-center gap-4">
          <div className="w-14 h-14 rounded-xl bg-lojack-blue-500/10 flex items-center justify-center">
            <Radio size={28} className="text-lojack-blue-400" />
          </div>
          <div>
            <h2 className="text-xl font-bold text-white">{t.comm_title}</h2>
            <p className="text-gray-400 text-sm mt-1">{t.comm_subtitle}</p>
          </div>
        </div>
        <CommunicationsExportButton />
      </div>

      <CountryPolicyWidget />
      <SmsHealthWidget variant="it" />
      <EmailHealthWidget variant="it" />
      <SalesforceHealthWidget />
    </div>
  );
};

export default CommunicationsTab;
